import axios from "axios";
import { SAVE_USER_CONNECTED, LOGOUT_USER, FETCH_CART_SUCCESS } from "./userActionTypes";

export const saveUserConnected = (user) => ({
    type: SAVE_USER_CONNECTED,
    payload: user,
});

export const logoutUser = () => ({
    type: LOGOUT_USER,
});

export const fetchCartSuccess = (cart) => ({
    type: FETCH_CART_SUCCESS,
    payload: cart,
});

export const refreshAccessToken = (refreshToken) => async (dispatch) => {
    const TOKEN_URL = process.env.REACT_APP_GET_TOKEN_URL

    try {
        const response = await axios.post(TOKEN_URL, { refreshToken });
        const { accessToken, user, providedRefreshToken } = response.data;

        // Mettez à jour le store avec le nouveau token
        dispatch(saveUserConnected({ accessToken: accessToken, user: user, refreshToken: providedRefreshToken }));

        return accessToken; // Retourne le nouveau token pour l'utiliser dans la requête Axios
    } catch (error) {
        console.error("Refresh token error:", error);
        throw new Error("Unable to refresh token");
    }
};
